import * as React from 'react';

import { ConfirmModal } from '@/components/ConfirmModal';

interface ConfirmDeleteModalProps<T> {
    target: T | null;
    title: string;
    getDescription: (target: T) => React.ReactNode;
    onConfirm: () => void;
    onCancel: () => void;
}

/** A ConfirmModal preset for the "confirm before deleting a specific item" pattern. */
export function ConfirmDeleteModal<T>({
    target,
    title,
    getDescription,
    onConfirm,
    onCancel,
}: ConfirmDeleteModalProps<T>) {
    return (
        <ConfirmModal
            open={target !== null}
            onOpenChange={(open) => !open && onCancel()}
            title={title}
            description={target ? getDescription(target) : ''}
            confirmText="Delete"
            confirmVariant="destructive"
            onConfirm={onConfirm}
            onCancel={onCancel}
        />
    );
}
